<h1 class="text-2xl md:text-4xl font-semibold tracking-tight mb-8">
	<slot />
</h1>
